import { api } from "../component/constent"; 
// Change this import to your existing axios/api file if required.

// ======================================================
// GET NEXT SRNO
// ======================================================
export const getAccountOfficeNextSrNo = async () => {
  const response = await api.get( "/entry/account-office/next-srno" );
  return response.data;
};

// ======================================================
// LIST
// ======================================================
export const getAccountOfficeList = async ({
  page = 1,
  limit = 25,
  search = "",
  month,
  year,
}) => {
  const response = await api.get(
    "/entry/account-office",
    {
      params: {
        page,
        limit,
        search,
        month,
        year,
      },
    }
  );

  return response.data;
};

// ======================================================
// ADD
// ======================================================
export const createAccountOffice = async (data) => {
  const response = await api.post(
    "/entry/account-office",
    data
  );

  return response.data;
};

// ======================================================
// UPDATE
// ======================================================
export const updateAccountOffice = async (srno, data) => {
  const response = await api.put(
    `/entry/account-office/${srno}`,
    data
  );

  return response.data;
};

// ======================================================
// DELETE
// ======================================================
export const deleteAccountOffice = async (srno, { month, year }) => {
  const response = await api.delete(
    `/entry/account-office/${srno}`,
    {
      data: {
        month,
        year,
      },
    }
  );

  return response.data;
};